/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
var Staff = function (quality) {
  return {
    slot: 'weapon',
    type: 'staff',
    quality: quality,
    damageMod: quality * 0.2,
    magicDamageMod: quality * 0.2,
    learning: Math.round(1 + quality * 2.5),
    mana: Math.round(1 + quality * 2.5),
    willpower: Math.round(1 + quality * 2.5),
    magicalGravity: quality,
  };
};
module.exports = Staff;
